module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iI2ZmY2UwMCIgZD0iTTAgMzQxLjMzOGg1MTIuMDA1djE3MC42N0gweiIvPgogIDxwYXRoIGQ9Ik0wIDBoNTEyLjAwNXYxNzAuNjdIMHoiLz4KICA8cGF0aCBmaWxsPSIjZDAwIiBkPSJNMCAxNzAuNjdoNTEyLjAwNXYxNzAuNjY4SDB6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/de.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/de.svg
// module chunks = 0